module.exports = __webpack_public_path__ + "img/teacher-lesson-1.57510235.png";